export default "__VITE_ASSET__82ff8637__"